<template>
  <div class="animated fadeIn reports">
    <b-row id = "teamFilter" >
      <!-- <b-col lg=2 offset=8>
        <a v-if="isAdminRole"> {{ $t('TEAMS.TEAMS') }}</a>
        <b-form-select style="text-transform: capitalize;"
            v-model="teamID"
            v-if="isAdminRole"
            :options="teams"
            >
        </b-form-select>
      </b-col> -->
      <b-col lg=2 offset=10>
        <div>
        {{ $t('Users') }}
          <div>
            <b-form-select style="text-transform: capitalize;"
                v-model="userID"
                :options="users"
                >
            </b-form-select>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-card no-body>
      <b-row v-match-heights="{el: ['.eq-height']}">
        <b-col lg="2" v-for="reportCard in reportCards" :key="reportCard['id']" v-if="showReportCards">
          <b-card v-ripple no-body class="eq-height text-black bg-white"  @click="pCardFilter(reportCard['text'])">
            <div class="bar" :class="reportCard['bg']"></div>
            <b-card-body>
              <b-row class="top-layer">
                <div class="h1 mb-0">
                  <animated-number :value="reportCard['value'] || 0" :formatValue="formatNumber" :duration="1000"/>
                </div>
                <div class="h1 text-right mb-4" :class="reportCard['tc']">
                  <i :class="reportCard['icon']"></i>
                </div>
              </b-row>
              <small class="text-black text-uppercase font-weight-bold">
                <strong><div style="height: 36px;">{{ $t('UPLOAD_DROPDOWN.'+reportCard['key']) }}<br></div></strong>
                {{ $t('ANALYTICS.TOTAL_PROCESSED') }} : {{ reportCard['processed'] }}<br>
                {{ $t('ANALYTICS.TOTAL_REJECTED') }} : {{ reportCard['rejected']  }}<br>
              </small>
              <b-progress class="progress-black progress-xs mt-3" :value="25"/>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="2" v-else>
          <b-card no-body class="eq-height text-black bg-white">
            <b-card-body>
              <content-placeholders>
                <content-placeholders-img style="height: 140px"/>
              </content-placeholders>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4">
          <b-card no-body class="bg-white">
            <b-row slot="header" class="ml-0">
              <h5>{{ $t('ANALYTICS.FORM_WORKFLOW_STATS') }}</h5>
            </b-row>
            <b-card-body>
              <timeline v-if="showChart">
                <timeline-item v-for="(count, processed) in processWorkflowStat" :key="processed" :class="'stats-' + processed">
                  <span class="h5 font-weight-bold">
                    <animated-number :value="count || 0" :formatValue="formatNumber" :duration="1000"/>
                  </span> {{ $t('COMMON.'+processed.toUpperCase()) }}
                </timeline-item>
              </timeline>
              <content-placeholders v-else>
                <content-placeholders-img style="height: 300px"/>
              </content-placeholders>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="8">
          <b-card no-body class="bg-white">
            <b-row slot="header" class="p-0" style ="margin-top: -19px;">
              <b-col sm="3" class="mt-auto">
                <h5 v-if="selectedDateFilterType === 'week'" > {{$t('ANALYTICS.WEEKLY_REPORT')}}</h5>
                <h5 v-else > {{$t('ANALYTICS.DAILY_REPORT')}}</h5>
              </b-col>
              <b-col sm="1.5" class="mt-auto">
                <h6> {{ $t('COMMON.FILTER_BY') }} </h6>
              </b-col>
              <b-col sm="2" class="group-by">
                <b-form-select v-model="selectedDateFilterType" :options="setFilterOptions"></b-form-select>
              </b-col>
              <b-col sm="1.5" class="mt-auto">
                <h6> {{ $t('COMMON.DATE_RANGE') }} </h6>
              </b-col>
              <b-col sm="4" class="mt-auto">
                <date-picker range v-model="dateRange" lang="en" format="YYYY-MM-DD" append-to-body :clearable="false" width="220px"></date-picker>
              </b-col>
            </b-row>
            <b-card-body>
              <line-chart v-if="showChart" :lineData="lineData" :lineLabels="lineLabels" :height="247"> </line-chart>
              <content-placeholders v-else>
                <content-placeholders-img style="height: 300px"/>
              </content-placeholders>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <div id="recent-forms">
        <b-card no-body bg-variant="light" class="received-form">
          <b-row slot="header" class="p-0">
            <b-col sm="3" class="mt-auto">
              <h5>{{ $t('ANALYTICS.RECENT_FORMS') }}</h5>
            </b-col>
            <b-col sm="0" class="mt-auto" style="margin-left: -78px;">
              <h6>{{ $t('ANALYTICS.PROCESS_TYPE') }}</h6>
            </b-col>
            <b-col sm="3" class="mt-auto">
              <b-form-select style="text-transform: capitalize;" v-model="selectedProcessType"
                            :options="setOptions"
                            @input ="filterProcessedFormsByType" >
              </b-form-select>
            </b-col>
            <b-col sm="0" class="mt-auto">
              <h6 v-if="selectedProcessType == 'enrollment forms'">{{ $t('ANALYTICS.TEMPLATE') }}</h6>
            </b-col>
            <b-col sm="2" class="mt-auto">
              <b-form-select style="text-transform: capitalize;" v-if="selectedProcessType == 'enrollment forms'"
                              v-model="selectedTemplate"
                              :options="templates"
                              @input ="filterProcessedFormsByTemplate" >
              </b-form-select>
            </b-col>
            <b-col sm="3" class="mt-auto">
              <b-row>
                <b-col xs="6" class="mt-auto">
                  {{ $t('COMMON.PROCESSED') }}
                  <c-switch type="3d" variant="success" :checked="filterProcessed" @change="pSwitchChanged" />
                </b-col>
                <b-col xs="6" class="mt-auto">
                  {{ $t('COMMON.REJECTED') }}
                  <c-switch type="3d" variant="danger" :checked="filterRejected" @change="rSwitchChanged" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <div class="report-table">
            <b-table show-empty striped :empty-text="$t('COMMON.NO_RECORD')" hover responsive="sm" variant="danger" v-if="showProcessedForms" :items="processedForms" :fields="tableFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
              <template slot="HEAD_title" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_pages" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_confidence_score" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_identified" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_rejection_reason" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
              <template slot="HEAD_view_link" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            </b-table>
            <content-placeholders v-else >
              <content-placeholders-text :lines="12"/>
            </content-placeholders>
            <infinite-loading
              :distance="distance"
              spinner="spiral"
              @infinite="infiniteHandler"
              ref="infiniteLoading">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
          </div>
        </b-card>
      </div>
    </b-card>

      <b-modal hide-header-close id="reportContent" :title="$t('ANALYTICS.REPORT_CONTENT')" header-bg-variant="light" ref="downloadReportsModal" centered>
        <b-card>
          <b-row class="mb-3">
            <b-col cols="3"> {{ $t('COMMON.DATE_RANGE') }} </b-col>
            <b-col sm="4" class="mt-auto">
              <date-picker range v-model="dateRangeCSV" lang="en" format="YYYY-MM-DD" :clearable="false" width="220px" confirm></date-picker>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3"> {{ $t('COMMON.FILTER_BY') }} </b-col>
            <b-col sm="4" class="mt-auto">
              <b-form-select id = "filterBy" :options="filterOptions" v-model="selectedDateFilterTypeCSV">
                </b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="isAdminRole" class="mb-3">
            <b-col cols="3"> {{ $t('TEAMS.TEAMS') }} </b-col>
            <b-col sm="4" class="mt-auto">
              <b-form-select id = "filterBy" style="text-transform: capitalize;"
                v-model="expTeamID"
                :options="teams"
                >
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3"> {{ $t('Users') }} </b-col>
            <b-col sm="4" class="mt-auto">
              <b-form-select id = "filterBy" style="text-transform: capitalize;"
                v-model="expUserID"
                :options="users" >
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="11">
              <p style="text-align: left; color: red;"> *{{ $t('ANALYTICS.RECENT_FORM_MSG') }} </p>
            </b-col>
          </b-row>
        </b-card>
        <div slot="modal-footer">
          <b-btn size="sm" variant="secondary" @click="generateCSV"> {{ $t('COMMON.GENERATE') }} </b-btn>
          <b-btn size="sm" variant="light" @click="hidedownloadReportsModal"> {{ $t('COMMON.CLOSE') }} </b-btn>
        </div>
      </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { Timeline, TimelineItem } from 'vue-cute-timeline'
import AnimatedNumber from 'animated-number-vue'
import { mapGetters } from 'vuex'
import lineChart from './LineChart'
import cSwitch from '@/components/Switch'
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'
import InfiniteLoading from 'vue-infinite-loading'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'reports-form',
  data () {
    return {
      option_keys: [],
      reportCards: [],
      showReportCards: false,
      processWorkflowStat: null,
      lineData: [],
      lineLabels: [],
      showChart: false,
      processTypes: [],
      templates: [],
      filterProcessed: true,
      filterRejected: true,
      processedForms: [],
      selectedProcessType: null,
      selectedTemplate: null,
      distance: Infinity,
      lastFormId: -1,
      sortBy: 'id',
      sortDesc: true,
      showProcessedForms: false,
      tableFields: [
        { key: 'id', sortable: true },
        { key: 'title', label: 'COMMON.TITLE', sortable: true },
        { key: 'pages', label: 'ANALYTICS.PAGES', sortable: false },
        { key: 'confidence_score', label: 'ANALYTICS.CONFIDENCE', sortable: true },
        { key: 'identified', label: 'ANALYTICS.IDENTIFIED', sortable: true },
        { key: 'rejection_reason', label: 'ANALYTICS.REJECTED', sortable: true }
      ],
      dateRange: [moment().subtract(1, 'months'), moment()],
      dateRangeCSV: [moment().subtract(1, 'months'), moment()],
      selectedDateFilterType: 'day',
      selectedDateFilterTypeCSV: 'day',
      filterOptions: [],
      teams: [],
      teamID: null,
      users: null,
      userID: null,
      expUserID: null,
      expTeamID: null

    }
  },
  components: {
    'line-chart': lineChart,
    'c-switch': cSwitch,
    'date-picker': DatePicker,
    Timeline,
    TimelineItem,
    AnimatedNumber,
    Multiselect,
    InfiniteLoading
  },
  computed: {
    ...mapGetters(['idToken', 'selectedRolesData', 'userRoleOrder', 'isAdminRole', 'currentUserId']),
    setOptions () {
      this.processTypes = [{ text: this.$t('ANALYTICS.SELECT_PROCESS_TYPE'), value: null, disabled: true }]
      this.processTypes = this.processTypes.concat(this.option_keys.map(processType => { return { text: this.$t('UPLOAD_DROPDOWN.' + processType.key), value: processType.value } }))
      return this.processTypes
    },
    setFilterOptions () {
      this.filterOptions = [{
        text: this.$t('COMMON.' + 'SELECT'),
        value: null,
        disabled: true
      },
      {
        text: this.$t('COMMON.' + 'WEEK'),
        value: 'week'
      },
      {
        text: this.$t('COMMON.' + 'DAY'),
        value: 'day'
      }]
      return this.filterOptions
    }
  },
  watch: {
    dateRange: function () {
      if (this.dateRange[0] && this.dateRange[1]) {
        this.fetchReceivedFormsReport()
      }
    },
    selectedDateFilterType: function () {
      this.fetchReceivedFormsReport()
    },
    teamID: function () {
      this.filterByTeam()
    },
    userID: function (newUserID, oldUserID) {
      this.filterByUser()
    },
    expTeamID: function () {
      this.teamID = this.expTeamID
      this.expUserID = null
    }
  },
  created () {
    let roles = _.slice(this.selectedRolesData, 0, this.userRoleOrder)
    this.roles = roles.map(role => { return role.id })
  },
  mounted () {
    this.$root.$on('exportReports', (status) => {
      this.dateRangeCSV = this.dateRange
      this.selectedDateFilterTypeCSV = this.selectedDateFilterType
      this.expUserID = this.userID
      this.expTeamID = this.teamID
      this.$refs.downloadReportsModal.show()
    })
  },
  beforeDestroy () {
    this.$root.$off('exportReports', this.status)
  },
  methods: {
    generateCSV () {
      this.download_reports()
    },
    hidedownloadReportsModal () {
      this.$refs.downloadReportsModal.hide()
    },
    formatNumber (value) {
      return value.toFixed(0)
    },
    pCardFilter (processType) {
      this.selectedProcessType = processType
      this.filterProcessed = true
      this.selectedTemplate = null
      this.fetchProcessedForms()
      var offset = document.getElementById('recent-forms').offsetTop - 100
      window.scroll({
        top: offset,
        left: 0,
        behaviour: 'smooth'
      })
    },
    pSwitchChanged () {
      this.filterProcessed = !this.filterProcessed
      this.fetchProcessedForms()
    },
    rSwitchChanged () {
      this.filterRejected = !this.filterRejected
      // For rejected switch to be on, no template should be selected
      if (this.filterRejected) { this.selectedTemplate = null }
      this.fetchProcessedForms()
    },
    filterProcessedFormsByType () {
      this.selectedTemplate = null
      this.fetchProcessedForms()
    },
    filterProcessedFormsByTemplate () {
      // Whenever a template is selected, rejected switch to be off
      if (this.selectedTemplate) {
        this.filterRejected = false
      }
      this.fetchProcessedForms()
    },
    filterByUser () {
      this.fetchReports()
      this.fetchTemplates()
      this.fetchProcessedForms()
    },
    filterByTeam () {
      if (this.isAdminRole) {
        this.userID = null
        this.fetchReports()
        this.fetchTemplates()
        this.fetchReceivedFormsReport()
        this.fetchProcessedForms()
      }
    },
    fetchReports () {
      Vue.axios.get('reports', { headers: { Authorization: `Bearer ${this.idToken}` }, params: { teamID: this.teamID, roles: this.roles, userID: this.userID, userRoleOrder: this.userRoleOrder } })
        .then(res => {
          let categoryProcessDetails = res.data.category_process_details
          this.option_keys = res.data.process_types.map(processType => { return { key: processType.key, value: processType.value } })
          if (this.isAdminRole) {
            this.users = [{text: 'All', value: null}].concat(res.data.users.map(user => { return {text: user.username, value: user.id} }))
          } else {
            this.users = res.data.users.map(user => { return {text: user.username, value: user.id} })
          }
          this.showChart = true
          this.showReportCards = true
          this.fetchCardDetails(categoryProcessDetails)
        })
        .catch(error => {
          console.log(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchTemplates () {
      Vue.axios.get('template_docs', { headers: { Authorization: `Bearer ${this.idToken}` }, params: { teamID: this.teamID, userID: this.userID } })
        .then(res => {
          this.processWorkflowStat = res.data.processed_forms
          this.templates = [{
            text: this.$t('TEMPLATE.SELECT_TEMPLATE'),
            value: null
          }].concat(res.data.template_docs.map(templateDoc => {
            return { value: templateDoc.id, text: templateDoc.title }
          }))
        })
        .catch(error => {
          console.log(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchReceivedFormsReport () {
      let filterBy = this.selectedDateFilterType
      let startDate = moment(this.dateRange[0]).format('YYYY-MM-DD')
      let endDate = moment(this.dateRange[1]).format('YYYY-MM-DD')
      Vue.axios.get('reports/received_forms', { headers: { Authorization: `Bearer ${this.idToken}` }, params: { startDate: startDate, endDate: endDate, filterBy: filterBy, teamID: this.teamID } })
        .then(res => {
          let reportsData = res.data.reports
          this.lineData = reportsData.line_data
          this.lineLabels = reportsData.line_labels
        })
        .catch(error => {
          console.log(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchProcessedForms () {
      this.processedForms = []
      this.distance = Infinity
      this.lastFormId = -1
      this.showProcessedForms = false
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
    },
    infiniteHandler ($state) {
      let params = {
        process_type: this.selectedProcessType,
        template_doc_id: this.selectedTemplate,
        processed: this.filterProcessed,
        rejected: this.filterRejected,
        last_form_id: this.lastFormId,
        team_id: this.teamID,
        user_id: this.userID
      }
      Vue.axios.get('reports/processed_forms', { headers: { Authorization: `Bearer ${this.idToken}` }, params: params })
        .then(res => {
          let forms = res.data.forms
          if (forms.length > 0) {
            this.processedForms = this.processedForms.slice().concat(forms)
            this.lastFormId = forms[forms.length - 1]['id']
            this.distance = 100
            this.showProcessedForms = true
            this.sortBy = 'id'
            this.sortDesc = true
            $state.loaded()
          } else {
            this.distance = 100
            this.showProcessedForms = true
            $state.complete()
          }
        })
        .catch(error => {
          console.log(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchCardDetails (categoryProcessDetails) {
      this.reportCards = [
        {id: 1, value: categoryProcessDetails['enrollment forms'].total, icon: 'fa fa-file-text', key: 'ENROLLMENT_FORMS', text: 'enrollment forms', received: categoryProcessDetails['enrollment forms'].total, processed: categoryProcessDetails['enrollment forms'].processed, rejected: categoryProcessDetails['enrollment forms'].rejected, bg: 'bg-primary', tc: 'text-primary'},
        {id: 2, value: categoryProcessDetails['insurance cards'].total, icon: 'fa fa-id-card', key: 'INSURANCE', text: 'insurance cards', received: categoryProcessDetails['insurance cards'].total, processed: categoryProcessDetails['insurance cards'].processed, rejected: categoryProcessDetails['insurance cards'].rejected, bg: 'bg-success', tc: 'text-success'},
        {id: 3, value: categoryProcessDetails['drivers license'].total, icon: 'fa fa-id-card-o', key: 'DL', text: 'drivers license', received: categoryProcessDetails['drivers license'].total, processed: categoryProcessDetails['drivers license'].processed, rejected: categoryProcessDetails['drivers license'].rejected, bg: 'bg-info', tc: 'text-info'},
        {id: 4, value: categoryProcessDetails['invoice'].total, icon: 'fa fa-file-text-o', key: 'INVOICE', text: 'invoice', received: categoryProcessDetails['invoice'].total, processed: categoryProcessDetails['invoice'].processed, rejected: categoryProcessDetails['invoice'].rejected, bg: 'bg-warning', tc: 'text-warning'},
        {id: 5, value: categoryProcessDetails['lease documents'].total, icon: 'fa fa-file-text', key: 'LEASE', text: 'lease documents', received: categoryProcessDetails['lease documents'].total, processed: categoryProcessDetails['lease documents'].processed, rejected: categoryProcessDetails['lease documents'].rejected, bg: 'bg-danger', tc: 'text-danger'},
        {id: 6, value: categoryProcessDetails['license agreement'].total, icon: 'fa fa-file-text-o', key: 'SLA', text: 'license agreement', received: categoryProcessDetails['license agreement'].total, processed: categoryProcessDetails['license agreement'].processed, rejected: categoryProcessDetails['license agreement'].rejected, bg: 'bg-danger', tc: 'text-danger'}
      ]
    },
    download_reports () {
      let title = 'reports_'
      if (this.teams.length > 0) {
        let teamName = this.teams.filter(team => team.value === this.expTeamID)[0]['text']
        let userName = this.users.filter(user => user.value === this.expUserID)[0]['text']
        teamName = teamName.replace(/ /g, '_')
        userName = userName.replace(/ /g, '_')
        if (teamName === 'All' && userName === 'All') {
          teamName = userName = ''
          title = title + 'All'
        } else {
          title = title + teamName + '_' + userName
        }
      }
      let payload = {
        filterBy: this.selectedDateFilterTypeCSV,
        startDate: moment(this.dateRangeCSV[0]).format('YYYY-MM-DD'),
        endDate: moment(this.dateRangeCSV[1]).format('YYYY-MM-DD'),
        teamID: this.expTeamID,
        userID: this.expUserID
      }
      Vue.axios.post('reports/download.csv', payload, { headers: { 'Authorization': `Bearer ${this.idToken}` } })
        .then(res => {
          let csvData = res.data
          var downloadLink = document.createElement('a')
          downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData)
          downloadLink.download = title + '_' + moment().format() + '.csv'
          document.body.appendChild(downloadLink)
          downloadLink.click()
          this.$refs.downloadReportsModal.hide()
          downloadLink.remove()
        })
        .catch(error => {
          console.log(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.reports {
  .card {
    cursor: pointer;
    background: #ebeef3;
    border-radius: 10px;

    .bar {
      width: 100%;
      height: 10px;
      border-radius: 10px 10px 0 0;
    }

    .card-header {
      border-radius: 10px 10px 0 0;
      background-color: #e7e7e7;
      padding: 1rem;
    }
  }

  select {
    border-radius: 6px;
  }

  .group-by {
    margin-top: 13px;
  }

  .custom-select {
    background: #fff;
    padding: 0.5rem;
  }

  .top-layer {
    justify-content: space-between;
    padding: 0 1.25em;
  }

  .report-table {
    max-height: 26.5rem;
    overflow-y: scroll;
    border-radius: 0 0 10px 10px;
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,.5);
      -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
}

.stats-unmatched{
  padding-bottom: 0;
}

.eq-height {
  border: none;
  border-radius: 2px;
  box-shadow: 0px 2px 3px 2px, rgba(0,0,0,0.03)
}

#filterBy {
  width: 220px;
}
#teamFilter {
  padding-bottom: 6px;
}
</style>
<style>

  .stats-pending .timeline-circle {
    background-color: #20a8d8;
  }

  .stats-unmatched .timeline-circle {
    background-color: #f86c6b;
  }

  .stats-accepted .timeline-circle {
    background-color: #4dbd74;
  }

  .stats-verified .timeline-circle {
    background-color: orange;
  }
</style>



// WEBPACK FOOTER //
// src/views/reports/Form.vue